import React, { useEffect, useState } from "react";
import CurrentMembershipCard from "../../../Components/CurrentMembershipCard";
import { upgradeIcon } from "../../../assets/images";
import { Link, useNavigate } from "react-router-dom";
import Footer from "../../../Components/common/Footer";
import { useDispatch, useSelector } from "react-redux";
import { GetPlanStatus } from "../../../api/RenewPlan";
import moment from "moment";
import { GetLastUpgradeData, markExistingUserData } from "../../../api/common";
import { Modal } from "../../../Components/ui";
import { setUserData } from "../../../redux/actions/authActions";

export default function PlanStatus() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);
  const [planData, setPlanData] = useState({});
  const [upgradeLink, setUpgradeLink] = useState(
    "/app/upgrade/select-membership"
  );

  const [confirmDetailsModal, setConfirmDetailsModal] = useState(false);
  const [check, setCheck] = useState(false);

  const getPlanData = async () => {
    try {
      const res = await GetPlanStatus(user?.id);

      if (res.status === 200) {
        const respData = res.data.data;

        setPlanData(respData);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getPlanData();
    getLastApplicationStatus();
  }, []); // eslint-disable-line

  const getLastApplicationStatus = async () => {
    try {
      const resp = await GetLastUpgradeData(user?.id);
      if (resp.status === 200) {
        const respData = resp.data;
        if (respData?.application_form_completion === false) {
          setUpgradeLink("/app/upgrade/membership-form");
        } else {
          console.log("else");
          if (respData?.application_review_completion === false) {
            setUpgradeLink(
              "/app/upgrade/application-review/" +
              btoa(respData.application.app_id)
            );
          } else {
            if (respData?.application_payment_completion === false) {
              setUpgradeLink(
                "/app/upgrade/checkout/" + btoa(respData.application.app_id)
              );
            } else {
              setUpgradeLink("/app/upgrade/select-membership");
            }
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleRenew = () => {
    if (user.manual === 1 || user.manual === 4) {
      setConfirmDetailsModal(true);
    } else {
      navigate(`/app/checkout/${btoa(planData.app_id)}`, { replace: true });
    }
  };

  const handleRenewConfirm = async (confirmation) => {
    if (confirmation === true) {
      try {
        const resp = await markExistingUserData();
        if (resp.status === 200) {
          if (resp.data.app_id) {
            dispatch(setUserData({ ...user, manual: 0 }));
            navigate(`/app/checkout/${btoa(resp.data.app_id)}`, {
              replace: true,
            });
          }
        }
      } catch (error) {
        console.log(error);
      }
    }
    if (confirmation === false) {
      navigate(`/user/update-details/${btoa(user?.id)}/renew`, {
        replace: false,
      });
    }

    setConfirmDetailsModal(false);
  };

  return (
    <>
      <div className="customContainer">
        {planData?.Plan &&
          planData?.Plan.toString().toLowerCase() !== "active" ? (
          <div className="headingTexts">
            {/* <h2 style={{ color: "red" }}>Your Membership Plan Expired.</h2> */}
            <h2 style={{ color: "red" }}>Renewal is Pending for FY 2026-2027.</h2>
            {planData?.is_renew_allow === true && (
              <p>
                Please renew it to continue accessing our services. Thank you!
              </p>
            )}
          </div>
        ) : (
          <div className="headingTexts">
            <h2 style={{ color: "green" }}>Renewal Done for FY 2026-2027.</h2>
          </div>
        )}

        <div
          className={
            "row " +
            (planData.Plan &&
              planData.Plan.toString().toLowerCase() !== "active"
              ? " mt-5"
              : "mt-3")
          }
        >
          <h6 className="mb-3">Plan Details</h6>
          <div className="col-md-6 col-lg-4">
            <CurrentMembershipCard data={planData} />
          </div>
          <div className="col-md-6 col-lg-4">
            {planData.Plan_Name &&
              planData.Plan_Name.toString().toLowerCase() !== "platinum" && (
                <Link
                  className="customFile h-100"
                  style={{ borderColor: "#F26C21" }}
                  to={upgradeLink}
                >
                  <img src={upgradeIcon} alt="" />
                  <p className="text-black mt-3">Upgrade Membership</p>
                </Link>
              )}
          </div>
        </div>
      </div>
      {confirmDetailsModal && (
        <Modal
          className="save-draft-modal confirm-details-modal"
          modalTitle="Confirmation"
          handleCloseModal={() => {
            setConfirmDetailsModal(false);
          }}
          footerButton={false}
        >
          {/* <img src={pendingIcon} alt="" /> */}
          {user.pdf_standalone ? (
            <>
              <p className="text-center m-0">
                Please confirm the current documents for your company available
                with EEMA are correct.
              </p>
              <a href={user.pdf_standalone} target="blank" className="my-3">
                View Documents
              </a>
              <div className="form-check form-check-inline eligibleText mb-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="inlineCheckbox11"
                  name="check"
                  checked={check}
                  onChange={(e) => setCheck(e.target.checked)}
                />
                <label
                  className="form-check-label"
                  htmlFor="inlineCheckbox11"
                  style={{ fontSize: "12px" }}
                >
                  I confirm that I have gone through the documents, they are
                  correct as on date {moment().format("DD-MM-YYYY")}
                </label>
              </div>
              <div className="d-flex justify-content-center">
                <button
                  disabled={!check}
                  className="btn btn-primary me-2"
                  onClick={() => handleRenewConfirm(true)}
                >
                  Yes
                </button>
                <button
                  disabled={!check}
                  className="btn btn-primary"
                  onClick={() => handleRenewConfirm(false)}
                >
                  No
                </button>
              </div>
            </>
          ) : (
            <>
              <p className="text-center m-0">Kindly upload your documents.</p>
              <div className="d-flex justify-content-center mt-3">
                <button
                  className="btn btn-primary"
                  style={{ fontSize: "15px" }}
                  onClick={() => handleRenewConfirm(false)}
                >
                  Upload Documents
                </button>
              </div>
            </>
          )}
        </Modal>
      )}
      <Footer
        hideBackButton
        isNextAllowed={planData && planData?.is_renew_allow === true}
        nextButtonAction={() => handleRenew()}
        nextButtonText="Renew Plan"
        className="justify-content-end"
      />
    </>
  );
}
